/** The Stencil Progress Tracker's ring size, which the Figma indicator matches. */
export const STEP_INDICATOR_SIZE_PX = 24;
